/**
 * 本地SVG图标组件
 * 替代Font Awesome，减少外部依赖
 */

import React from 'react';

const IconBase = ({ children, size = 16, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`icon ${className}`}
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    {...props}
  >
    {children}
  </svg>
);

// 常用图标
export const SearchIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </IconBase>
);

export const EditIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
  </IconBase>
);

export const UserIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </IconBase>
);

export const LogoutIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16,17 21,12 16,7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </IconBase>
);

export const MenuIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </IconBase>
);

export const CloseIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </IconBase>
);

export const ArrowRightIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12,5 19,12 12,19"></polyline>
  </IconBase>
);

export const ArrowLeftIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="19" y1="12" x2="5" y2="12"></line>
    <polyline points="12,19 5,12 12,5"></polyline>
  </IconBase>
);

export const HeartIcon = ({ size, className, filled = false, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path
      d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
      fill={filled ? 'currentColor' : 'none'}
    ></path>
  </IconBase>
);

export const ShareIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
  </IconBase>
);

export const MoreIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </IconBase>
);

export const TagIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
    <line x1="7" y1="7" x2="7.01" y2="7"></line>
  </IconBase>
);

export const CalendarIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </IconBase>
);

export const ImageIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21,15 16,10 5,21"></polyline>
  </IconBase>
);

export const UploadIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7,10 12,15 17,10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </IconBase>
);

// 导航相关图标
export const HomeIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9,22 9,12 15,12 15,22"></polyline>
  </IconBase>
);

export const BookIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
  </IconBase>
);

export const FileTextIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14,2 14,8 20,8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10,9 9,9 8,9"></polyline>
  </IconBase>
);

export const ArchiveIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <polyline points="21,8 21,21 3,21 3,8"></polyline>
    <rect x="1" y="3" width="22" height="5"></rect>
    <line x1="10" y1="12" x2="14" y2="12"></line>
  </IconBase>
);

export const InfoIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </IconBase>
);

// 编辑器工具栏图标
export const BoldIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>
    <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>
  </IconBase>
);

export const ItalicIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="19" y1="4" x2="10" y2="4"></line>
    <line x1="14" y1="20" x2="5" y2="20"></line>
    <line x1="15" y1="4" x2="9" y2="20"></line>
  </IconBase>
);

export const LinkIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </IconBase>
);

export const ListIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="8" y1="6" x2="21" y2="6"></line>
    <line x1="8" y1="12" x2="21" y2="12"></line>
    <line x1="8" y1="18" x2="21" y2="18"></line>
    <line x1="3" y1="6" x2="3.01" y2="6"></line>
    <line x1="3" y1="12" x2="3.01" y2="12"></line>
    <line x1="3" y1="18" x2="3.01" y2="18"></line>
  </IconBase>
);

export const QuoteIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M6 10.5C6 6.916 8.916 4 12.5 4s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5H12v4l-6-4z"></path>
  </IconBase>
);

export const CodeIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <polyline points="16,18 22,12 16,6"></polyline>
    <polyline points="8,6 2,12 8,18"></polyline>
  </IconBase>
);

export const VideoIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <polygon points="23,7 16,12 23,17"></polygon>
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
  </IconBase>
);

export const MicrophoneIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"></path>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
    <line x1="12" y1="19" x2="12" y2="23"></line>
    <line x1="8" y1="23" x2="16" y2="23"></line>
  </IconBase>
);

export const FilmIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
    <circle cx="8" cy="9" r="2"></circle>
    <path d="M18 9l-2-2-4 4"></path>
  </IconBase>
);

export const MusicIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M9 18V5l12-2v13"></path>
    <circle cx="6" cy="18" r="3"></circle>
    <circle cx="18" cy="16" r="3"></circle>
  </IconBase>
);

export const HashtagIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="4" y1="9" x2="20" y2="9"></line>
    <line x1="4" y1="15" x2="20" y2="15"></line>
    <line x1="10" y1="3" x2="8" y2="21"></line>
    <line x1="16" y1="3" x2="14" y2="21"></line>
  </IconBase>
);

export const SpinnerIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={`fa-spin ${className}`} {...props}>
    <path d="M21 12a9 9 0 11-6.219-8.56"></path>
  </IconBase>
);

export const PenIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
  </IconBase>
);

export const SettingsIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </IconBase>
);

// 通用图标映射，方便从Font Awesome迁移
export const iconMap = {
  'fas fa-search': SearchIcon,
  'fas fa-edit': EditIcon,
  'fas fa-user': UserIcon,
  'fas fa-sign-out-alt': LogoutIcon,
  'fas fa-bars': MenuIcon,
  'fas fa-times': CloseIcon,
  'fas fa-arrow-right': ArrowRightIcon,
  'fas fa-arrow-left': ArrowLeftIcon,
  'fas fa-heart': HeartIcon,
  'fas fa-share': ShareIcon,
  'fas fa-ellipsis-h': MoreIcon,
  'fas fa-tag': TagIcon,
  'fas fa-calendar': CalendarIcon,
  'fas fa-image': ImageIcon,
  'fas fa-home': HomeIcon,
  'fas fa-book': BookIcon,
  'fas fa-file-text': FileTextIcon,
  'fas fa-archive': ArchiveIcon,
  'fas fa-info-circle': InfoIcon,
  // 编辑器工具栏图标
  'fas fa-bold': BoldIcon,
  'fas fa-italic': ItalicIcon,
  'fas fa-link': LinkIcon,
  'fas fa-list-ul': ListIcon,
  'fas fa-quote-right': QuoteIcon,
  'fas fa-code': CodeIcon,
  'fas fa-video': VideoIcon,
  'fas fa-microphone': MicrophoneIcon,
  'fas fa-film': FilmIcon,
  'fas fa-music': MusicIcon,
  'fas fa-hashtag': HashtagIcon,
  'fas fa-spinner': SpinnerIcon,
  'fas fa-pen': PenIcon,
  'fas fa-cog': SettingsIcon
};

// 动态组件编辑器图标
export const PlusIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="M12 5v14m-7-7h14"></path>
  </IconBase>
);

export const TrashIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <polyline points="3,6 5,6 21,6"></polyline>
    <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
  </IconBase>
);

export const MoveUpIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="m18 15-6-6-6 6"></path>
  </IconBase>
);

export const MoveDownIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <path d="m6 9 6 6 6-6"></path>
  </IconBase>
);

export const SlidersIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="4" x2="4" y1="21" y2="14"></line>
    <line x1="4" x2="4" y1="10" y2="3"></line>
    <line x1="12" x2="12" y1="21" y2="12"></line>
    <line x1="12" x2="12" y1="8" y2="3"></line>
    <line x1="20" x2="20" y1="21" y2="16"></line>
    <line x1="20" x2="20" y1="12" y2="3"></line>
    <line x1="1" x2="7" y1="14" y2="14"></line>
    <line x1="9" x2="15" y1="8" y2="8"></line>
    <line x1="17" x2="23" y1="16" y2="16"></line>
  </IconBase>
);

export const AlignJustifyIcon = ({ size, className, ...props }) => (
  <IconBase size={size} className={className} {...props}>
    <line x1="3" x2="21" y1="6" y2="6"></line>
    <line x1="3" x2="21" y1="12" y2="12"></line>
    <line x1="3" x2="21" y1="18" y2="18"></line>
  </IconBase>
);

// 通用图标组件
export const Icon = ({ name, size = 16, className = '', ...props }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return <IconComponent size={size} className={className} {...props} />;
};
